import React from 'react';
import { Card, Empty } from 'antd';

/**
 * 交易统计
 * 职责：展示交易相关的统计与图表；当前为占位页，后续接入真实数据与可视化。
 * 交互：暂无，后续支持筛选维度与时间范围。
 */
const TransactionStatsPage = () => {
  return (
    <div style={{ padding: '24px' }}>
      <h1>交易统计</h1>
      <Card>
        <Empty 
          description="交易统计功能开发中..."
          style={{ padding: '60px 0' }}
        />
      </Card>
    </div>
  );
};

export default TransactionStatsPage;
